import React from 'react';
import { Flex, Radio, Switch, Typography } from 'antd';
import { Divider } from '@/shared/ui/Divider';
import { Settings, FontSize, FONT_SIZES } from '@/models/settings';
import styles from './AppearanceSection.module.css';

const { Text } = Typography;

interface AppearanceSectionProps {
  settings: Settings;
  darkTheme: boolean;
  onUpdate: (partial: Partial<Settings>) => void;
}

export const AppearanceSection: React.FC<AppearanceSectionProps> = ({
  settings,
  darkTheme,
  onUpdate,
}) => (
  <div className={styles.rows}>
    <Flex
      id="dark-mode"
      align="center"
      justify="space-between"
      className={styles.row}
    >
      <Flex vertical>
        <Text>{darkTheme ? 'Dark mode' : 'Light mode'}</Text>
        <Text type="secondary" className={styles.hint}>
          {darkTheme
            ? 'Using dark theme across the app.'
            : 'Using light theme across the app.'}
        </Text>
      </Flex>
      <Switch
        checked={darkTheme}
        onChange={(checked) => onUpdate({ darkMode: checked })}
      />
    </Flex>

    <Divider />

    <Flex
      id="compact-mode"
      align="center"
      justify="space-between"
      className={styles.row}
    >
      <Flex vertical>
        <Text>{settings.compactMode ? 'Compact mode' : 'Relaxed mode'}</Text>
        <Text type="secondary" className={styles.hint}>
          {settings.compactMode
            ? 'Using a denser, compact layout.'
            : 'Using relaxed spacing and padding.'}
        </Text>
      </Flex>
      <Switch
        checked={settings.compactMode}
        onChange={(checked) => onUpdate({ compactMode: checked })}
      />
    </Flex>

    <Divider />

    <Flex
      id="font-size"
      align="center"
      justify="space-between"
      className={styles.row}
    >
      <Flex vertical>
        <Text>Font size</Text>
        <Text type="secondary" className={styles.hint}>
          Adjust the font size across the interface.
        </Text>
      </Flex>
      <Radio.Group
        className={styles.fontSizeGroup}
        value={settings.fontSize}
        onChange={(e) => onUpdate({ fontSize: e.target.value as FontSize })}
      >
        {FONT_SIZES.map((opt) => (
          <Radio.Button key={opt} value={opt}>
            <span
              className={styles.fontSizeOption}
              data-size={opt}
              title={opt.charAt(0) + opt.slice(1).toLowerCase()}
            >
              Aa
            </span>
          </Radio.Button>
        ))}
      </Radio.Group>
    </Flex>
  </div>
);
